import { render, staticRenderFns } from "./nopay.vue?vue&type=template&id=1e36ff3a&scoped=true&"
import script from "./nopay.vue?vue&type=script&lang=js&"
export * from "./nopay.vue?vue&type=script&lang=js&"
import style0 from "./nopay.vue?vue&type=style&index=0&id=1e36ff3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e36ff3a",
  null
  
)

export default component.exports